import React from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import NoteAPI from '../../api/NoteAPI';
import Util from '../../util/Util';
import ApiUiController from '../../controller/ApiUiController';
import './NotePopup.css';

class NotePopup extends React.Component {

  constructor(props) {
    super(props);
    this.note = {
      id: 0, type: props.note && props.note.type ? props.note.type : 1,
      model_no: props.model_no, model_id: props.model_id
    };
    this.state = { inApiCall: false, changed: false };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.note && this.props.note && props.note.id !== this.props.note.id) {
      this.note = {
        id: 0, type: props.note && props.note.type ? props.note.type : 1,
        model_no: props.model_no, model_id: props.model_id, text: props.note ? props.note.text : ''
      };
      this.setState({ ...this.state, changed: !this.state.changed, text: props.note ? props.note.text : '' });
    } else if (props.note && props.note.id !== this.note.id) {
      this.note = {
        id: props.note.id, type: props.note && props.note.type ? props.note.type : 1,
        model_no: props.model_no, model_id: props.model_id, text: props.note ? props.note.text : ''
      };
      this.setState({ ...this.state, changed: !this.state.changed });
    }
  }

  onChange = temp => {
    const text = temp ? Util.templateToData(temp.text, this.props.data, this.props.model.fields).template : '';
    this.setState({ ...this.state, temp, text });
  };
  onValueChange = evt => this.setState({ ...this.state, text: evt.target.value });
  onPhone = phone => this.setState({ ...this.state, phone });

  onSave = () => {
    if (this.state.text === '') {
      Util.showNotification('Error', 'Note is empty', 'danger');
      return;
    }
    this.setState({ ...this.state, inApiCall: true });
    NoteAPI.save(this.note, this.onSaved, this.failure);
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Note Added successfully', 'success');
    this.setState({ ...this.state, inApiCall: false });
    this.props.onHide();
    if (this.props.reload) {
      this.props.reload();
    }
  };

  failure = res => {
    Util.showNotification('Failed', res.message, 'danger');
    this.setState({ ...this.state, inApiCall: false });
  };

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}
        size="md" aria-labelledby="contained-modal-title-vcenter" centered >

        <ApiUiController inApiCall={this.state.inApiCall}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter"> Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: { items: ['undo', 'redo', '|', 'bold', 'italic'] },
                  initialData: this.note.text
                }}
                data={this.note.text}
                onChange={(event, editor) => this.note.text = editor.getData()}
              />
            </Form>
          </Modal.Body>
          <Modal.Footer><Button onClick={this.onSave}>Submit</Button></Modal.Footer>
        </ApiUiController>
      </Modal>
    );
  }
}
export default NotePopup;
